<template>
  <nav class="kp-modular-panel" id="kp-modular-panel">
    <menu-buttons></menu-buttons>
    <steps></steps>
    <types></types>
    <view-mode></view-mode>
    <themes></themes>
    <config></config>
    <trigger-button></trigger-button>
    <modifiers></modifiers>
    <advanced-config></advanced-config>
  </nav>
</template>

<script>
import MenuButtons from './buttons/Main.vue';
import Steps from './steps/Main';
import Types from './types/Main.vue';
import ViewMode from './viewmode/Main.vue';
import Themes from './themes/Main.vue';
import Config from './config/Main.vue';
import TriggerButton from './triggerbutton/Main.vue';
import Modifiers from './modifiers/Main.vue';
import AdvancedConfig from './advancedconfig/Main.vue';

export default {
  components: {
    MenuButtons,
    Steps,
    Types,
    ViewMode,
    Themes,
    Config,
    TriggerButton,
    Modifiers,
    AdvancedConfig,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?37d49a94
 **/